import { ErrorTranslationService } from '../services/errors/error-translation.service';

/**
 * Factory function to preload error translations on app initialization
 * This ensures error messages are translated immediately when errors occur
 */
export function errorTranslationInitializerFactory(
  errorTranslationService: ErrorTranslationService
): () => Promise<any> {
  return () => {
    return errorTranslationService.loadErrorTranslations();
  };
}
